<template>
  <rest-page :loading="loading">
    <div
      v-if="$store.getters.activeGames.length === 0 && !loading && !hasAccess"
    >
      <gamification-upsell-introduction @scrollTo="scrollToSection" />
      <gamification-thunderbite-messaging />
      <div class="sticky">
        <gamification-book-a-demo-banner />
      </div>
      <gamification-deliver-the-right-game />
      <gamification-thunderbite-games />
      <gamification-drive-relevant-players />
      <gamification-add-to-omnichannel-strategy />
      <gamification-hear-from-our-customers />
      <gamification-games-carousel />
      <gamification-lets-play id="letsPlaySection" />
      <gamification-frequently-asked-questions />
    </div>
    <div v-else-if="!loading">
      <page-header
        :title="
          $store.getters.embeddedTitle || $t('Gamification_GamesHub_Page_Title')
        "
      >
        <template v-if="hasAccess" #actions>
          <el-button
            type="primary"
            @click="dialogVisible = true"
            icon="el-icon-circle-plus-outline"
          >
            {{ $t('Gamification_GamesHub_Add_Game_Btn') }}
          </el-button>
        </template>
      </page-header>
      <page-content class="games-dashboard-ct">
        <div class="content-ct">
          <games-hub-your-games v-if="games.length > 0" :games="games" />
          <games-to-purchase
            v-if="gamesToPurchase.length > 0"
            :core-games="gamesToPurchase"
          />
        </div>
        <bespoke-game-banner class="banner" />
      </page-content>
      <add-game-dialog
        v-if="dialogVisible"
        :dialog-visible="dialogVisible"
        @close="closeAddGameDialog"
      />
    </div>
  </rest-page>
</template>
<script>
import GamificationUpsellIntroduction from '@/modules/gamification/components/games-hub-upsell/GamificationUpsellIntroduction.vue'
import GamificationThunderbiteMessaging from '@/modules/gamification/components/games-hub-upsell/GamificationThunderbiteMessaging.vue'
import GamificationBookADemoBanner from '@/modules/gamification/components/games-hub-upsell/GamificationBookADemoBanner.vue'
import GamificationDeliverTheRightGame from '@/modules/gamification/components/games-hub-upsell/GamificationDeliverTheRightGame.vue'
import GamificationThunderbiteGames from '@/modules/gamification/components/games-hub-upsell/GamificationThunderbiteGames.vue'
import GamificationDriveRelevantPlayers from '@/modules/gamification/components/games-hub-upsell/GamificationDriveRelevantPlayers.vue'
import GamificationAddToOmnichannelStrategy from '@/modules/gamification/components/games-hub-upsell/GamificationAddToOmnichannelStrategy.vue'
import GamificationHearFromOurCustomers from '@/modules/gamification/components/games-hub-upsell/GamificationHearFromOurCustomers.vue'
import GamificationGamesCarousel from '@/modules/gamification/components/games-hub-upsell/GamificationGamesCarousel.vue'
import GamificationLetsPlay from '@/modules/gamification/components/games-hub-upsell/GamificationLetsPlay.vue'
import GamificationFrequentlyAskedQuestions from '@/modules/gamification/components/games-hub-upsell/GamificationFrequentlyAskedQuestions.vue'
import PageHeader from '@/common/components/page/PageHeaderNew'
import GamesHubYourGames from '@/modules/gamification/components/games-hub-dashboard/GamesHubYourGames.vue'
import PageContent from '@/common/components/page/PageContent.vue'
import GamesToPurchase from '@/modules/gamification/components/games-hub-dashboard/GamesToPurchase.vue'
import BespokeGameBanner from '@/modules/gamification/components/games-hub-dashboard/BespokeGameBanner.vue'
import AddGameDialog from '@/modules/gamification/components/games-hub-dashboard/AddGameDialog.vue'
import { $hasFeature } from '@/core/utils/VueAcl'
import RestPage from '@/common/components/rest/RestPage.vue'

export default {
  name: 'GamesHubPage',
  components: {
    RestPage,
    AddGameDialog,
    BespokeGameBanner,
    GamesToPurchase,
    PageContent,
    GamesHubYourGames,
    PageHeader,
    GamificationFrequentlyAskedQuestions,
    GamificationLetsPlay,
    GamificationGamesCarousel,
    GamificationHearFromOurCustomers,
    GamificationAddToOmnichannelStrategy,
    GamificationDriveRelevantPlayers,
    GamificationThunderbiteGames,
    GamificationDeliverTheRightGame,
    GamificationBookADemoBanner,
    GamificationThunderbiteMessaging,
    GamificationUpsellIntroduction
  },

  data() {
    return {
      dialogVisible: false,
      loading: true
    }
  },

  created() {
    if (
      this.$can('Gamification:FullAccess') ||
      this.$can('Gamification:ReadAccess') ||
      this.$can('Gamification:DesignAccess')
    ) {
      this.$store
        .dispatch('fetchActiveGames')
        .then(() => {
          if (this.hasAccess || this.$store.getters.activeGames.length) {
            this.$store
              .dispatch('fetchGamesToPurchase')
              .catch(error => {
                this.error = error
              })
              .finally(() => {
                this.loading = false
              })
          } else {
            this.loading = false
          }
        })
        .catch(error => {
          this.error = error
          this.loading = false
        })
    }
  },

  methods: {
    scrollToSection(sectionId) {
      document
        .getElementById(sectionId)
        .scrollIntoView({ behavior: 'smooth', block: 'center' })
    },

    closeAddGameDialog() {
      this.dialogVisible = false
    }
  },

  computed: {
    hasAccess() {
      return this.$isRole('admin') || this.$isRole('admin-support')
    },
    gamesToPurchase() {
      return this.$store.getters.gamesToPurchase.filter(
        game => !this.getActiveGameIds.includes(game.id)
      )
    },
    games() {
      return this.$store.getters.gamesToPurchase.filter(game =>
        this.getActiveGameIds.includes(game.id)
      )
    },
    getActiveGameIds() {
      return this.$store.getters.activeGames.map(game => game.game_id)
    }
  },

  mounted() {
    if (!$hasFeature('enableGamification')) {
      this.$router.push({ path: '/' })
    }
  }
}
</script>

<style scoped>
div.sticky {
  position: sticky;
  top: 0;
  z-index: 100;
}

>>> .page {
  overflow: auto;
}

.page-content {
  background-color: #fff;
}

.games-dashboard-ct {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 24px;
  min-height: 100vh;
}

.banner {
  width: 100%;
}

.content-ct {
  display: flex;
  flex-direction: column;
  gap: 24px;
}
</style>



// WEBPACK FOOTER //
// src/modules/gamification/pages/GamesHubPage.vue